import { useState, useEffect, useCallback } from 'react';

const useSaveFavouriteJob = (jobPostId) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isSaved, setIsSaved] = useState(null);
   
  const fetchSavedJob = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employees/favorite-jobs/${jobPostId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setIsSaved(data.isSaved);
    } catch (error) {
      console.error('Error fetching saved job status:', error);
    } finally {
      setLoading(false);
    }
  }, [jobPostId]); // Only depend on jobPostId

  useEffect(() => {
    // Only fetch saved job status if we're not on the application page
    // and if we have a valid jobPostId
    if (jobPostId && !window.location.pathname.includes('/aplicar')) {
      fetchSavedJob();
    }
  }, [fetchSavedJob, jobPostId]); // Added jobPostId to dependencies

  const saveFavouriteJob = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employees/favorite-jobs/${jobPostId}`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}), // Send empty JSON object to satisfy Content-Type
        credentials: 'include',
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to save the job as favorite: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
  
      setSuccess(data.message);
      setIsSaved(true); 
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { saveFavouriteJob, loading, error, isSaved, success };
};

export default useSaveFavouriteJob;
